import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import LoadingButton from '../LoadingButton';

function TwoOptionAlert({
  onConfirm,
  onCancel,
  titleText,
  confirmText,
  cancelText,
}) {
  return (
    <>
      <DialogTitle id='alert-dialog-title'>{titleText}</DialogTitle>
      <DialogActions>
        <LoadingButton
          onClick={onConfirm}
          color='primary'
          text={confirmText}
          autoFocus
        />
        <LoadingButton
          onClick={onCancel}
          variant='outlined'
          text={cancelText}
        />
      </DialogActions>
    </>
  );
}

export default TwoOptionAlert;
